import { Shop } from "./Shop";

export abstract class ShopRepository {
    abstract all(): Promise<Shop[]>;
    abstract confirmed(): Promise<Shop[]>;
    abstract valid(shop: Shop): Promise<any>;
    abstract confirm(shop: Shop): Promise<any>;
    abstract addNote(shop: Shop, note: string): Promise<any>;
}